import PageError from './PageError';

export default PageError;
